import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const removeAlarmPolicyAPI = async (id, t, successText) => {
  await axios({
    url: `/api/v2/alarm/policy/delete`,
    method: "DELETE",
    data: {
      id
    }
  });
  successHandling(t, successText);
  return true;
};
